import { render, staticRenderFns } from "./EditAccountDetails.vue?vue&type=template&id=e88d195c&scoped=true"
import script from "./EditAccountDetails.vue?vue&type=script&lang=js"
export * from "./EditAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./EditAccountDetails.vue?vue&type=style&index=0&id=e88d195c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88d195c",
  null
  
)

export default component.exports